// extracted by mini-css-extract-plugin
export default {"icon":"AccountType_icon__r-rjx"};